<template>
    <div class="sc-detail-body">
        <!-- 요약 -->
        <div class="sc-summary">
            <div class="sc-summary-text">
                <template v-if="dayText">
                    {{ $t("매주") }} <b>{{ dayText }}</b>
                    <template v-if="times.length">
                        · <b>{{ times.join(", ") }}</b>
                    </template>
                    {{ times.length ? $t("에") : "" }}
                    <br />
                </template>
                <template v-else>{{ $t("제어 요일이 지정되지 않았습니다.") }}<br /></template>
                <template v-if="typeNames.length">
                    <b>{{ typeNames.join(" · ") }}</b> {{ $t("중") }} <b>{{ targetText }}</b
                    >{{ $t("를 제어합니다.") }}
                </template>
                <template v-else>{{ $t("제어 대상이 지정되지 않았습니다.") }}</template>
            </div>
            <div class="sc-summary-days">
                <span
                    v-for="day in DAYS"
                    :key="day.key"
                    class="sc-day-circle"
                    :class="{ on: !!(detail.repeatConfig || {})[day.key] }"
                >
                    {{ day.label }}
                </span>
            </div>
        </div>

        <!-- 타임라인 -->
        <div>
            <div class="sc-section-head">
                <h3>{{ $t("실행 타임라인") }}</h3>
                <span class="sc-meta">
                    {{ $t("하루") }} {{ events.length }}{{ $t("회") }} · {{ $t("예외일") }} {{ exceptCount
                    }}{{ $t("일 제외") }}
                </span>
            </div>
            <div class="sc-timeline" aria-hidden="true">
                <div class="sc-timeline-bar"></div>
                <div
                    v-for="(event, i) in events"
                    :key="i"
                    class="sc-timeline-mark"
                    :style="{ left: percent(event.schdHour) + '%' }"
                ></div>
            </div>
            <div class="sc-timeline-scale" aria-hidden="true">
                <span>00</span><span>06</span><span>12</span><span>18</span><span>24</span>
            </div>

            <div v-if="events.length" class="sc-list-box">
                <div v-for="(event, i) in events" :key="i" class="sc-event-item">
                    <span class="t">{{ hhmm(event.schdHour) }}</span>
                    <span class="n">{{ event.schdEventName }}</span>
                    <span class="v">{{ event.label || "-" }}</span>
                </div>
            </div>
            <div v-else class="sc-meta" style="margin-top: 8px">{{ $t("등록된 실행 스케줄이 없습니다.") }}</div>
        </div>

        <!-- 최근 실행 -->
        <div class="sc-lastrun">
            <template v-if="lastRun && lastRun.date">
                <div class="head">{{ $t("최근 실행") }} · {{ formatDate(lastRun.date, "YYYY-MM-DD HH:mm:ss") }}</div>
                <div class="body">
                    {{ $t("성공") }} {{ lastRun.ok }} ·
                    <span :class="{ fail: lastRun.fail > 0 }">{{ $t("실패") }} {{ lastRun.fail }}</span>
                </div>
                <button type="button" class="link" @click="$emit('goto-history')">{{ $t("이력 보기") }} →</button>
            </template>
            <template v-else>
                <div class="head">{{ $t("최근 실행") }}</div>
                <div class="body">{{ $t("아직 실행 이력이 없습니다.") }}</div>
            </template>
        </div>
    </div>
</template>

<script>
import {
    DAYS,
    hhmm,
    timelinePercent,
    formatDate,
    summarizeDays,
    activeExceptMap,
    equipTypeName,
} from "../../utils/scheduleFormat";

export default {
    props: {
        detail: { type: Object, required: true },
        eventLabels: { type: Array, default: () => [] },
        lastRun: { type: Object, default: null },
    },
    data() {
        return { DAYS };
    },
    computed: {
        events() {
            // eventLabels 는 detail.events 원본 순서 기준이므로 정렬 전에 라벨을 붙인다
            return (this.detail.events || [])
                .map((event, i) => ({ ...event, label: this.eventLabels[i] }))
                .sort((a, b) => hhmm(a.schdHour).localeCompare(hhmm(b.schdHour)));
        },
        times() {
            return this.events.map((e) => hhmm(e.schdHour));
        },
        dayText() {
            return summarizeDays(this.detail.repeatConfig);
        },
        exceptCount() {
            return Object.keys(activeExceptMap(this.detail.exceptConfig)).length;
        },
        typeNames() {
            return (this.detail.targets || []).map((t) => equipTypeName(this.$store, t.equipType));
        },
        targetText() {
            const groups = (this.detail.groups || []).length;
            const equips = (this.detail.equips || []).length;
            const parts = [];
            if (groups) parts.push(`${this.$t("그룹")} ${groups}${this.$t("개")}`);
            if (equips) parts.push(`${this.$t("개별 설비")} ${equips}${this.$t("대")}`);
            return parts.length ? parts.join(", ") : this.$t("대상 미지정");
        },
    },
    methods: {
        hhmm,
        formatDate,
        percent: timelinePercent,
    },
};
</script>
